// components/results/GoalAlignment.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Card, ListGroup, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullseye, faCheckCircle, faTimesCircle, faMinusCircle } from '@fortawesome/free-solid-svg-icons';

const GoalAlignment = ({ alignmentData = [] }) => {
    if (!alignmentData || alignmentData.length === 0) {
        return null; // Don't render anything if no data
    }

    const getAlignmentStyle = (alignment) => {
        switch (alignment?.toLowerCase()) {
            case 'good':
                return { variant: 'success', icon: faCheckCircle, text: "Good Alignment" };
            case 'neutral':
                return { variant: 'info', icon: faMinusCircle, text: "Neutral" };
            case 'poor':
                return { variant: 'danger', icon: faTimesCircle, text: "Poor Alignment" };
            default:
                return { variant: 'secondary', icon: faBullseye, text: "N/A" };
        }
    };

    return (
        <Card className="shadow-sm mb-4">
            <Card.Header as="h5" className="bg-light text-primary border-bottom fw-bold p-3">
                <FontAwesomeIcon icon={faBullseye} className="me-2" /> Goal Alignment
            </Card.Header>
            <ListGroup variant="flush">
                {alignmentData.map((goalItem, index) => {
                    const style = getAlignmentStyle(goalItem.alignment);
                    return (
                        <ListGroup.Item key={index} className="p-3">
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <span className="fw-bold">{goalItem.goalType || "Unnamed Goal"}</span>
                                <Badge pill bg={style.variant} className="px-2 py-1">
                                    <FontAwesomeIcon icon={style.icon} className="me-1" />
                                    {style.text}
                                </Badge>
                            </div>
                            {goalItem.recommendation && (
                                <p className="mb-0 small text-muted">
                                    <span className='fw-bold'>Recommendation: </span>{goalItem.recommendation}
                                </p>
                            )}
                        </ListGroup.Item>
                    );
                })}
            </ListGroup>
        </Card>
    );
};

GoalAlignment.propTypes = {
    alignmentData: PropTypes.arrayOf(PropTypes.shape({
        goalType: PropTypes.string,
        alignment: PropTypes.oneOf(['good', 'neutral', 'poor', 'Good', 'Neutral', 'Poor']), // Allow for case variations
        recommendation: PropTypes.string
    }))
};

export default GoalAlignment;